import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

interface IPrivacyPolicy {
	isChecked: boolean;
	setIsChecked: (x: boolean) => void;
	showPopover: boolean;
}
const PrivacyPolicy = ({
	isChecked,
	setIsChecked,
	showPopover,
}: IPrivacyPolicy) => {
	const handleIsChecked = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;

		setIsChecked(checked);
	};
	return (
		<div>
			<div className="relative flex p-2 items-center relative">
				{!isChecked && showPopover && (
					<div className="absolute top-[-42px] left-0 bg-white rounded-lg shadow-lg p-2 absolute z-10">
						<div className="flex">
							<div className="mr-2">
								<ExclamationCircleIcon className="text-opus-yellow-200 w-5 h-5" />
							</div>
							<p className="text-sm">Please check the checkbox to proceed.</p>
						</div>
						<div className="absolute w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-white left-1/2 transform -translate-x-1/2 top-full"></div>
					</div>
				)}
				<input
					type="checkbox"
					id={"policy"}
					checked={isChecked}
					name="policy"
					className="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-0  checked:bg-transparent checked:border-gray-600 checked:text-gray-600"
					onChange={handleIsChecked}
				/>

				<div className="flex items-center space-x-2 ml-2">
					<div className="text-xs md:text-base">
						I agree to the{" "}
						<Link
							to={"/terms-and-condition"}
							className="text-opus-blue-100 underline hover:no-underline font-gilroy-semibold"
							target="_blank">
							Terms and Condition
						</Link>{" "}
						and{" "}
						<Link
							to={"/privacy-policy"}
							className="text-opus-blue-100 underline hover:no-underline font-gilroy-semibold"
							target="_blank">
							Privacy Policy
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
